import { useContext } from "react";
import { GroupContext } from "contexts";

export default () => useContext(GroupContext);
